import styled from 'styled-components';
import { defaultBorder, defaultBackground, defaultColors } from '../../../styles/style-guide';

export const Header = styled.header<{ $borderColor?: string }>`
  width: 100%;
  border-radius: 0.5rem;
  border: 1px solid ${({ $borderColor }) => ($borderColor || defaultBorder.primary)};
  background-color: white;
  padding: 1rem;
  font-weight: bold;
`;

export const Section = styled.section<{ $borderColor?: string; $backgroundColor?: string }>`
  width: 100%;
  margin-bottom: 1.5rem;
  border-radius: 0.5rem;
  border: 1px solid ${({ $borderColor }) => ($borderColor || defaultBorder.primary)};
  background-color: white;
  padding: 1rem;
`;

export const Title = styled.h2<{ $color?: string }>`
  font-weight: 600;
  color: ${({ $color }) => ($color || defaultColors.primary)};
`;

export const StatusButton = styled.button<{ $backgroundColor?: string }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  border-radius: 0.375rem;
  background-color: ${({ $backgroundColor }) => ($backgroundColor || defaultBackground.primary)};
  color: rgb(255 255 255 / 1);
  font-size: 0.75rem;
  line-height: 1rem;
  text-align: center;
`;

export const StatusText = styled.span<{ $color?: string }>`
  margin-left: 0.5rem;
  font-weight: 600;
  color: ${({ $color }) => ($color || defaultColors.primary)};
`;
